import React from "react";

export const ClientLogo = ({ type }) => {
  if (type === "emotions-clinic") {
    return (
      <div
        className="client-pdf-logo-box d-flex flex-column align-items-center justify-content-center"
        style={{
          border: "1.5px solid #d1d5db",
          borderRadius: "8px",
          padding: "16px 20px",
          background: "#ffffff",
          maxWidth: "190px",
          textAlign: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
        }}
      >
        <svg viewBox="0 0 160 140" width="120" height="105" xmlns="http://www.w3.org/2000/svg">
          {/* Curved text path */}
          <path
            id="curve"
            d="M 20,80 A 60,60 0 0,1 140,80"
            fill="none"
          />
          <text fontSize="10.5" fill="#8e2a6d" fontWeight="700" letterSpacing="0.5">
            <textPath href="#curve" startOffset="50%" textAnchor="middle">
              Education &amp; Training Centre
            </textPath>
          </text>
          
          {/* Colorful Central Icon (Heart / Person figure with vibrant petals) */}
          <g transform="translate(80, 75) scale(0.9)">
            {/* Left petal (coral/pink) */}
            <path
              d="M 0,0 C -18,-15 -24,-32 -10,-42 C 0,-50 12,-38 0,-15 Z"
              fill="#e7386c"
            />
            {/* Center head / petal (purple) */}
            <circle cx="0" cy="-36" r="6" fill="#8e2a6d" />
            {/* Right petal (blue/cyan) */}
            <path
              d="M 0,0 C 18,-15 24,-32 10,-42 C 0,-50 -12,-38 0,-15 Z"
              fill="#2e86de"
            />
            {/* Base swoosh */}
            <path
              d="M -16,6 C -5,14 5,14 16,6 C 10,18 -10,18 -16,6 Z"
              fill="#9b59b6"
            />
          </g>
          
          {/* Bottom text */}
          <text
            x="80"
            y="126"
            textAnchor="middle"
            fontSize="14"
            fontWeight="800"
            fill="#1e3799"
            fontFamily="'Inter', 'Segoe UI', sans-serif"
          >
            Emotions Clinic
          </text>
        </svg>
      </div>
    );
  }

  if (type === "pedal-power") {
    return (
      <div
        className="client-pdf-logo-box d-flex flex-column align-items-center justify-content-center"
        style={{
          border: "1.5px solid #d1d5db",
          borderRadius: "8px",
          padding: "12px 18px",
          background: "#ffffff",
          maxWidth: "190px",
          textAlign: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
        }}
      >
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px", width: "120px", marginBottom: "4px" }}>
          <div style={{ background: "#d4a919", color: "#ffffff", fontWeight: "900", fontSize: "14px", padding: "2px 4px", letterSpacing: "1px", borderRadius: "2px" }}>
            PEDAL
          </div>
          <div style={{ background: "#73b526", color: "#ffffff", fontWeight: "900", fontSize: "14px", padding: "2px 4px", letterSpacing: "1px", borderRadius: "2px" }}>
            POWER
          </div>
          <div style={{ background: "#5cb4b8", color: "#ffffff", fontWeight: "900", fontSize: "14px", padding: "2px 4px", letterSpacing: "1px", borderRadius: "2px" }}>
            PWER
          </div>
          <div style={{ background: "#1f83c7", color: "#ffffff", fontWeight: "900", fontSize: "14px", padding: "2px 4px", letterSpacing: "1px", borderRadius: "2px" }}>
            PEDAL
          </div>
        </div>
        <div style={{ fontSize: "7px", fontWeight: "800", color: "#475569", letterSpacing: "0.5px", textTransform: "uppercase" }}>
          Alyn Waters Country Park
        </div>
      </div>
    );
  }

  if (type === "godfrey-group") {
    return (
      <div
        className="client-pdf-logo-box d-flex align-items-center justify-content-center"
        style={{
          border: "1.5px solid #d1d5db",
          borderRadius: "8px",
          padding: "14px 18px",
          background: "#ffffff",
          maxWidth: "200px",
          textAlign: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
        }}
      >
        <svg viewBox="0 0 200 60" width="160" height="50" xmlns="http://www.w3.org/2000/svg">
          {/* Monogram G R */}
          <g transform="translate(5, 5)">
            <path
              d="M 25,5 C 14,5 5,14 5,25 C 5,36 14,45 25,45 C 33,45 39,40 42,33 L 31,33 C 29,35 27,37 25,37 C 18,37 13,32 13,25 C 13,18 18,13 25,13 C 30,13 34,16 36,20 L 44,14 C 40,8 33,5 25,5 Z"
              fill="#c69214"
            />
            <path
              d="M 28,15 L 42,15 C 47,15 50,18 50,23 C 50,27 47,30 43,31 L 51,45 L 41,45 L 35,33 L 34,33 L 34,45 L 28,45 Z M 34,21 L 34,28 L 41,28 C 43,28 44,27 44,24.5 C 44,22 43,21 41,21 Z"
              fill="#d4a342"
            />
          </g>
          {/* Text */}
          <text
            x="70"
            y="28"
            fontSize="18"
            fontWeight="900"
            fill="#1e293b"
            fontFamily="'Inter', 'Segoe UI', sans-serif"
            letterSpacing="1.5"
          >
            GODFREY
          </text>
          <text
            x="70"
            y="44"
            fontSize="12"
            fontWeight="700"
            fill="#c69214"
            fontFamily="'Inter', 'Segoe UI', sans-serif"
            letterSpacing="3"
          >
            GROUP
          </text>
        </svg>
      </div>
    );
  }

  if (type === "touch-point") {
    return (
      <div
        className="client-pdf-logo-box d-flex flex-column align-items-center justify-content-center"
        style={{
          border: "1.5px solid #d1d5db",
          borderRadius: "8px",
          padding: "12px 18px",
          background: "#ffffff",
          maxWidth: "190px",
          textAlign: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
        }}
      >
        <svg viewBox="0 0 160 120" width="130" height="95" xmlns="http://www.w3.org/2000/svg">
          {/* Circle of colorful hands / petals */}
          <g transform="translate(80, 48) scale(0.65)">
            {/* Top right - Coral / Pink */}
            <path
              d="M 12,-10 C 25,-25 45,-20 45,0 C 45,15 25,25 10,12 Z"
              fill="#e7386c"
              opacity="0.9"
            />
            {/* Right - Orange */}
            <path
              d="M 15,5 C 32,8 45,28 35,42 C 25,52 8,38 5,20 Z"
              fill="#ff9f43"
              opacity="0.9"
            />
            {/* Bottom right - Lime Green */}
            <path
              d="M 0,15 C 8,32 0,52 -15,50 C -28,48 -25,28 -10,15 Z"
              fill="#2ed573"
              opacity="0.9"
            />
            {/* Bottom left - Cyan / Teal */}
            <path
              d="M -12,10 C -28,20 -48,12 -45,-5 C -42,-18 -22,-20 -10,-5 Z"
              fill="#00d2d3"
              opacity="0.9"
            />
            {/* Top left - Purple */}
            <path
              d="M -10,-10 C -18,-28 -2,-48 15,-40 C 28,-32 20,-15 5,-5 Z"
              fill="#5f27cd"
              opacity="0.9"
            />
            {/* Center heart/dot */}
            <circle cx="0" cy="5" r="7" fill="#54a0ff" />
          </g>
          {/* Text */}
          <text
            x="80"
            y="94"
            textAnchor="middle"
            fontSize="12"
            fontWeight="800"
            fill="#0984e3"
            fontFamily="'Inter', 'Segoe UI', sans-serif"
            letterSpacing="0.5"
          >
            Access Support
          </text>
          <text
            x="80"
            y="110"
            textAnchor="middle"
            fontSize="9"
            fontWeight="700"
            fill="#636e72"
            fontFamily="'Inter', 'Segoe UI', sans-serif"
            letterSpacing="1"
          >
            TOUCH POINT
          </text>
        </svg>
      </div>
    );
  }

  if (type === "mployr") {
    return (
      <div
        className="client-pdf-logo-box d-flex flex-column align-items-center justify-content-center"
        style={{
          maxWidth: "320px",
          width: "100%",
          minHeight: "105px",
          textAlign: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
        }}
      >
        <img
          src="/images/case-study-mployr.png"
          alt="Mployr Logo"
          style={{
            width: "100%",
            maxWidth: "400px",
            maxHeight: "160px",
            objectFit: "contain",
            display: "block"
          }}
        />
      </div>
    );
  }

  if (type === "nail-tech-rich") {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          maxWidth: "150px",
          width: "100%",
          background: "transparent"
        }}
      >
        <img
          src="/images/nail-tech-logo.png"
          alt="Nail Tech Rich Logo"
          style={{
            width: "100%",
            maxWidth: "135px",
            maxHeight: "135px",
            objectFit: "contain",
            borderRadius: "25%",
            overflow: "hidden",
            display: "block",
          }}
        />
      </div>
    );
  }

  return null;
};
